// src/components/insights/InsightCard.jsx

import { Link } from "react-router-dom";

function InsightCard({ article }) {
  return (
    <Link to={`/insights/${article.slug}`} style={{ textDecoration: "none", color: "inherit" }}>
      <div className="insight-card">

        <img src={article.meta.coverImage} alt={article.meta.title} />

        <div className="insight-card-meta">
          {article.meta.category} · {article.meta.date}
        </div>

        <h2 className="insight-card-title">{article.meta.title}</h2>

        <p className="insight-card-excerpt">{article.meta.excerpt}</p>

        <span className="insight-card-readmore">Read more →</span>
      </div>
    </Link>
  );
}

export default InsightCard;